import { ActivityTagPill } from "PFApp/components/activity_tag_pill";
import { Inline } from "PFComponents/containers";
import { CustomValue } from "PFCore/types";

type ActivityTagCellProps = {
  value: CustomValue | CustomValue[];
};

export const ActivityTagCell = ({ value }: ActivityTagCellProps) => {
  if (!value) {
    return null;
  }
  const items = Array.isArray(value) ? value : [value];
  return (
    <Inline wrap="wrap">
      {items.map(({ id, text }) => (
        <ActivityTagPill key={id} tagName={text} />
      ))}
    </Inline>
  );
};
